export default __webpack_public_path__ + "static/headerbg-848ca9fe0bac9d172d2a985803273a83.png";